import React from "react";
import Footer from "../../Footer";

interface RootLayoutProps {
    children: React.ReactNode;
}

export default function RootLayout({ children }: RootLayoutProps) {
    return (
        <>
            {children}
            <Footer />
        </>
    );
}
